var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
export const CloseIcon = (_a) => {
    var { fill = "#191919" } = _a, props = __rest(_a, ["fill"]);
    return (_jsxs("svg", Object.assign({ width: "13", height: "12", viewBox: "0 0 13 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", sx: {
            width: 13,
            height: 12
        } }, props, { children: [_jsx("path", { d: "M13 12L7.95137 6L13 0L10.6201 0L5.57143 6L10.6201 12H13Z", fill: fill }), _jsx("path", { d: "M1.43987e-06 0L5.04863 6L0 12H2.37995L7.42857 6L2.37995 0H1.43987e-06Z", fill: fill })] })));
};
//# sourceMappingURL=CloseIcon.js.map